import { atom } from "jotai";

import { atomStreamConfigurations } from "../../atoms/atomsStream";

export const atomBroadcastDisabled = atom<boolean>(true);

atomBroadcastDisabled.debugLabel = "atomBroadcastDisabled";

/**
 * Derived atom: true when at least one stream output is enabled.
 *
 * Reads directly from `atomStreamConfigurations` so it reacts instantly
 * when the user saves stream-output settings (the save flow writes to
 * the atom *and* to IndexedDB).  A secondary `useLiveQuery` in
 * `useBroadcast` keeps the atom in sync with IndexedDB on startup.
 */

export const atomHaveOutputStream = atom<boolean>((get) => {
  const configs = get(atomStreamConfigurations);

  return Object.values(configs).some((cfg) => cfg?.enabled === true);
});

atomHaveOutputStream.debugLabel = "atomHaveOutputStream";

export const atomOnLive = atom<boolean>(false);

atomOnLive.debugLabel = "atomOnLive";

export const atomAuth = atom<string | null>(null);

atomAuth.debugLabel = "atomAuth";

export const atomLoadingAccount = atom<boolean>(true);

atomLoadingAccount.debugLabel = "atomLoadingAccount";

export const atomBroadcastLoading = atom<boolean>(false);

atomBroadcastLoading.debugLabel = "atomBroadcastLoading";

export const atomRecordingLoading = atom<boolean>(false);

atomRecordingLoading.debugLabel = "atomRecordingLoading";
